import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BazisInputOptionsButtonComponent } from '@bazis/form/components/base/options/input-options-button.component';

@Component({
    selector: 'app-input-options-button',
    templateUrl: './input-options-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputOptionsButtonComponent extends BazisInputOptionsButtonComponent {
    multiple = false; // данный вид отображения по макету. не предусматривает множественный выбор
}
